var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.content
  }, [_c('datepicker-palette', {
    directives: [{
      name: "grow",
      rawName: "v-grow"
    }, {
      name: "m-r",
      rawName: "v-m-r",
      value: 16,
      expression: "16"
    }],
    ref: "month",
    attrs: {
      "min": _vm.min,
      "max": _vm.max,
      "range": _vm.range,
      "value": _vm.value,
      "month": _vm.months[_vm.monthFromIdx],
      "hover-day": _vm.hoverDay,
      "first-day-offset": _vm.firstDayOffset
    },
    on: {
      "input": _vm.onInputValue,
      "hover:day": function hoverDay($event) {
        _vm.hoverDay = $event;
      },
      "prev-month": function prevMonth($event) {
        _vm.monthFromIdx > 0 ? _vm.monthFromIdx-- : undefined;
      },
      "next-month": function nextMonth($event) {
        _vm.monthFromIdx === _vm.months.length - 1 ? undefined : _vm.monthFromIdx++;
      }
    }
  }), _c('datepicker-palette', {
    directives: [{
      name: "grow",
      rawName: "v-grow"
    }],
    ref: "month",
    attrs: {
      "min": _vm.min,
      "max": _vm.max,
      "range": _vm.range,
      "value": _vm.value,
      "month": _vm.months[_vm.monthToIdx],
      "hover-day": _vm.hoverDay,
      "first-day-offset": _vm.firstDayOffset
    },
    on: {
      "input": _vm.onInputValue,
      "hover:day": function hoverDay($event) {
        _vm.hoverDay = $event;
      },
      "prev-month": function prevMonth($event) {
        _vm.monthToIdx > 0 ? _vm.monthToIdx-- : undefined;
      },
      "next-month": function nextMonth($event) {
        _vm.monthToIdx === _vm.months.length - 1 ? undefined : _vm.monthToIdx++;
      }
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }